import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { ModalButtonsProps } from "@/types";
import { ROUTES } from "@/consts";
import { DELETE_VOUCHER } from "../mutations";
import { LIST_VOUCHERS } from "../queries";

type UseDeleteVoucherProps = {
	ids: string[] | undefined;
	navigateAfterDelete?: boolean;
	cleanUp?: () => void;
};

const useDeleteVoucher = ({
	ids,
	navigateAfterDelete,
	cleanUp,
}: UseDeleteVoucherProps) => {
	const [mutation, { loading: deleteVoucherLoading }] =
		useMutation(DELETE_VOUCHER);

	const navigate = useNavigate();

	const buttons: ModalButtonsProps[] = [
		{
			title: "Delete Voucher",
			onClick: async () => {
				try {
					await mutation({
						variables: { ids },
						update: (cache) => {
							cache.evict({ fieldName: "listVouchers" });
						},
						refetchQueries: [
							{
								query: LIST_VOUCHERS,
							},
						],
					});
					cleanUp?.();
					if (navigateAfterDelete) {
						navigate(ROUTES.Vouchers, { replace: true });
					}
				} catch (err: any) {
					if (err.graphQLErrors[0].statusCode === 422) {
						const { errors } = err.graphQLErrors[0];
						message.error(Object.values(errors)[0] as string);
						return;
					}
					message.error(err?.message || "Something went wrong");
				}
			},
			type: "primary",
			loading: deleteVoucherLoading,
			danger: true,
		},
		{
			title: "Cancel",
			type: "default",
			close: true,
		},
	];

	return {
		buttons,
	};
};

export default useDeleteVoucher;
